import styled, { css } from "styled-components";
import React, {
  Component,
  Fragment,
  useContext,
  useState,
  useRef,
  useEffect,
} from "react";
import { ContextConsumer, GlobalContext } from './PA';
import PAtabs from "./PAtabs";
import {
  Button,
  Card,
  Input,
  FormGroup,
  RadioGroup,
  Select,
  Head,
  TagSelector,
  Icon,
  ButtonAction,
  Charts,
  ContentBlock,
  FormCaption,
  StatusDot,
} from "xsolla-uikit";
import { Switch, Route, Link } from "react-router-dom";

import { PAcolumnsTags } from "./../components/support/PAusersSubscribers";

import PAsolutionsNew from "./cards/PAsolutionsNew";

import { PAinfoCollapsible } from "./uikit2";

import {
  PAConnectorCard,
  PAconnectorGTM,
  PAconnectorGA,
  PAconnectorFB,
  PAconnectorPN,
  PAconnectorTW,
  PAconnectorMCH,
  PAconnectorWH,
  PAconnectorZapier,
  PAconnectorInv,
} from "./PAconnectors";

import PAloginStats from "./login/PAloginStats";
import PAh2 from "./PAh2";
import CardNew from "./PAcardNew";
import PAsubsCharts from "./subscriptions/PAsubsCharts";
import { PAoneApp } from "./dashboard/PAapps";
import { CssSectionHeader } from "./PASideBar";
import PAtopMenu, { CssProductIcon } from "./menu/PAtopMenu";
import { xsollaProducts } from "../data/xsollaProducts";
import { xsollaProductsStatus } from "../data/xsollaProductsStatus";
import { ProductIcon } from "../data/ProductIcon";

export default function PAdashboard({ hist, tabs }) {
  let globalContext = useContext(GlobalContext);

  let myRef = useRef();

  useEffect(() => {
    let hash = hist.history.location.hash;

    // debugger
    if (hash && myRef.current)
      window.scrollTo({ behavior: "smooth", top: myRef.current.offsetTop });

    // if (hash) {
    //   document.querySelector(`${hash}`)
    // }

    // debugger
  }, [myRef]);

  return (
    <Fragment>
      {/* <div style={{
    position: "sticky",
    top: 0,
    zIndex: 100,
    marginBottom: 24,
    background: useContext(GlobalContext).globalState.version === "misha"
                  ? "#D6E0E7"
                  : "#f5f9ff",
    // boxShadow: '-40px 0 0 0 rgb(245, 249, 255), 40px 0 0 0 rgb(245, 249, 255)
  }}>

    <FormGroup indentation="lg">
      <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "stretch",
              alignItems: 'center',
            }}
          >
            <PAh2 tag="h1" title="Dashboard" indentation="xs">
              &nbsp;&nbsp;&nbsp;&nbsp;
              <PAtabs
                handleTab = {(e)=>{
                  if (e === 'antifraud') {
                    hist.history.push('/antifraud/main')
                    return
                  }

                }}
                appearance="secondary"
                active = {0}
                // active={hist.match.params.keyId || Object.keys(tabs)[0]}
                // handleTab={nw => {
                  // hist.history.push(`/${root}/${nw}`);
                // }}
                items={[
                  {name:'Upgrade', stateName: '/dashboard/upgrade#users'},
                  {name:'Sales', stateName: 1},
                  {name:'Users', stateName: 2},
                  {name:'Antifraud', stateName: 'antifraud'},
                ]}
                // extra='123'

              />
          </PAh2>

          <div
          style={{display: 'flex', width: '100%', justifyContent: 'flex-end'}}>
<Select
              align="right"
              name=""
              size="sm"
              options={[
                { label: "Show all projects", value: 1 },
                { label: "Project 1", value: 2 },
                { label: "Project 2", value: 3 }
              ]}
              input={{
                name: "widgTheme",
                value: 1,
                onChange: () => {
                  void 0;
                }
              }}
            />
          </div>


    </div>
    </FormGroup>
    </div> */}

      <br />

      {/* <FormGroup indentation="lg">
        <div
            className="p_content-block p_content-block--brand"
            style={{maxHeight: 630, overflow: 'hidden'}}
            // style={{ cursor: uiState.shown ? "inherit" : "pointer" }}
          >
          <PAsolutionsNew limit={4} shown={true} all={false} />
        </div>
      </FormGroup> */}

      <br />
      <div ref={myRef}>
        <FormGroup indentation="lg">
          <PAdashPayouts />
        </FormGroup>
      </div>
    </Fragment>
  );
}

export const DashSection = styled.div`
  /* display: ${(cols) => (cols ? "static" : "grid")}; */
  display: grid;
  display: static;
  /* grid-template-columns: 1fr 280px; */
  /* grid-template-columns: 1fr; */
  grid-template-columns: 3fr 280px;
  grid-column-gap: 44px;
  grid-row-gap: 24px;
`;

export const PAdashConnectors = ({}) => {
  const [period, setPeriod] = useState(30);
  return (
    <FormGroup indentation="xlg" style={{ width: "100%" }}>
      <PAinfoCollapsible
        title="Connect apps"
        indentation="lg"
        counter={"0 / 2"}
        isOpen={true}
      >
        {/* <Notification style={{
        width: '100%', marginBottom: 44,}}> */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(100px, 260px))",
            columnGap: "16px",
            gridRowGap: "16px",
          }}
        >
          <PAconnectorMCH />
          <PAconnectorZapier />

          <PAconnectorGTM />
          <PAconnectorFB />
          <PAconnectorTW />
        </div>
      </PAinfoCollapsible>
      <br />
      <br />
    </FormGroup>
  );
};

export const PAdashPayouts = ({ empty  }) => {
  const [period, setPeriod] = useState(30);

  const optionsEmpty = {
    chart: {
      // height: 370,
      type: "line",
    },
    xAxis: {
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
    },
    yAxis: [
      {
        title: {
          text: "Gross revenue, USD",
        },
        labels: {
          format: "${value}",
          formatter: function() {
            const value = this.value;
            return value % 100 === 0 ? `$${value / 1000}k` : `$${value}`;
          },
        },
      },
      {
        title: {
          text: "Payments",
        },
        opposite: true,
      },
    ],
    series: [],
  };
  const optionsFull = {
    chart: {
      height: 370,
      type: "line",
    },
  xAxis: {
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
    },
    yAxis: [
      {
        title: {
          text: "Gross revenue, USD",
        },
        labels: {
          format: "${value}",
          formatter: function() {
            const value = this.value;
            return value % 100 === 0 ? `$${value / 1000}k` : `$${value}`;
          },
        },
      },
      {
        title: {
          text: "Payments",
        },
        opposite: true,
      },
    ],
    series: [
      {
        name: "Gross revenue",
        tooltip: {
          valuePrefix: "$",
        },
        type: "column",
        data: [1471, 7914, 6973, 3048, 5869, 4859, 5437],
      },
      {
        name: "Payments",
        yAxis: 1,
        data: [1233, 1444, 1421, 500, 1355, 1245, 1355],
      },
    ],
  };

  return (
    <div className="">
      {/* <PAh2 title="Sales" indentation="lg"/> */}

      <FormGroup indentation="lg">
        <DashSection
          // cols={true}
          cols={
            useContext(GlobalContext).globalState.version === "misha"
              ? false
              : true
          }
        >
          <ContentBlock>
          <FormGroup indentation="lg">
            <PAh2 title="Revenue" indentation='xlg'>
              <div style={{ marginTop: -16, marginLeft: 4 }}>
                <Select
                  size="sm"
                  autosize={true}
                  // disabled={this.disabled}
                  align="right"
                  name=""
                  options={[
                    { label: "Last week", value: 7 },
                    { label: "Last 30 days", value: 30 },
                    { label: "Last quarter", value: 90 },
                  ]}
                  searchable={false}
                  // dock={"right"}
                  input={{
                    // onChange: setDefCurr,
                    value: period,
                  }}
                />
              </div>
            </PAh2>
            </FormGroup>

            <FormGroup>
              <div className="balance-chart__metrics">
                <div className="balance-chart__metrics__metric">
                  <div className="statistic-card">
                    <div className="statistic-card__title">Gross revenue</div>
                    <div
                      className="statistic-card__value statistic-card__value--non-zero"
                      data-id="balance-chart__metrics__metric__value_gross_revenue"
                    >
                      {!empty && <span>$51,039.84</span>}
                      {empty && <span>$0</span>}


                    </div>
                    <div className="statistic-card__change">
                      <div className="statistic-card__arrow statistic-card__arrow--lose" />
                      <div className="statistic-card__percent statistic-card__percent--lose">
                        -78.93%
                      </div>
                      <div className="statistic-card__label">
                        Compared to the previous 30 days
                      </div>
                    </div>
                  </div>
                </div>
                <div className="balance-chart__metrics__metric">
                  <div className="statistic-card">
                    <div className="statistic-card__title">Payments</div>
                    <div
                      className="statistic-card__value statistic-card__value--non-zero"
                      data-id="balance-chart__metrics__metric__value_transactions_count"
                    >
                      {!empty && <span>951</span>}
                      {empty && <span>0</span>}

                    </div>
                    <div className="statistic-card__change">
                      <div className="statistic-card__arrow statistic-card__arrow--lose" />
                      <div className="statistic-card__percent statistic-card__percent--lose">
                        -82.77%
                      </div>
                      <div className="statistic-card__label">
                        Compared to the previous 30 days
                      </div>
                    </div>
                  </div>
                </div>
                <div className="balance-chart__metrics__metric">
                  <div className="statistic-card">
                    <div className="statistic-card__title">Paying users</div>
                    <div
                      className="statistic-card__value statistic-card__value--non-zero"
                      data-id="balance-chart__metrics__metric__value_active_users"
                    >

                      {!empty && <span>943</span>}
                      {empty && <span>0</span>}

                    </div>
                    <div className="statistic-card__change">
                      <div className="statistic-card__arrow statistic-card__arrow--lose" />
                      <div className="statistic-card__percent statistic-card__percent--lose">
                        -80.72%
                      </div>
                      <div className="statistic-card__label">
                        Compared to the previous 30 days
                      </div>
                    </div>
                  </div>
                </div>
                <div className="balance-chart__metrics__metric">
                  <div className="statistic-card">
                    <div className="statistic-card__title">
                      Average payment value
                    </div>
                    <div
                      className="statistic-card__value statistic-card__value--non-zero"
                      data-id="balance-chart__metrics__metric__value_average_sale"
                    >
                      {!empty && <span>$52.82</span>}
                      {empty && <span>0</span>}

                    </div>
                    <div className="statistic-card__change">
                      <div className="statistic-card__arrow statistic-card__arrow--gross" />
                      <div className="statistic-card__percent statistic-card__percent--gross">
                        20.79%
                      </div>
                      <div className="statistic-card__label">
                        Compared to the previous 30 days
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </FormGroup>

            {/* SALES FULL */}

            {!empty && (
              <FormGroup label="">
                <CSSchartfix>
                  <Charts
                    // state="empty"
                    options={empty ? optionsEmpty : optionsFull}
                    // options={empty ? optionsEmpty : optionsFull}
                  />
                </CSSchartfix>
              </FormGroup>
            )}
          </ContentBlock>

          {/* //TODO: варианты дашборда */}
          {/* {!empty && useContext(GlobalContext).globalState.version !== "misha" && ( */}
            <Provided product="game_store" />
          {/* )} */}
        </DashSection>
      </FormGroup>

      <br />
    </div>
  );
};

export const Provided = ({ product, type = "provided" }) => {
  return (
    <div style={{ marginBottom: 24 }}>
      {/* <CardNew style={{ flexGrow: 0, height: "auto" }}> */}
      <CssSectionHeader>
        {type === "provided" ? "Provided by" : "Upgrade"}
      </CssSectionHeader>

      {product === "game_store" && (
        <CSSprovidedGrid>
          <Link
            to="/game_store/goods"
            style={{ color: "#00244d", display: "block" }}
          >
            <CardNew style={{ flexGrow: 0, height: "auto" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 16,
                }}
              >
                <CssProductIcon size={"sm"}>
                  <ProductIcon size="sm" name="game_store" />
                </CssProductIcon>

                <div className="">My game: Regular edition</div>
              </div>

              <p style={{ display: "flex", alignItems: "center" }}>
                <StatusDot status={"enabled"} />
                &nbsp;&nbsp;&nbsp;Steam Game Keys:&nbsp;<b>165</b>
              </p>
              <p style={{ display: "flex", alignItems: "center" }}>
                <StatusDot status={"testing"} />
                &nbsp;&nbsp;&nbsp;GOG Game Keys:&nbsp;<b>13</b>
              </p>
            </CardNew>
          </Link>

          <Link
            to="/game_store/goods"
            style={{ color: "#00244d", display: "block" }}
          >
            <CardNew
              style={{ flexGrow: 0, height: "auto" }}
              // appearance="flatten"
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 16,
                }}
              >
                <CssProductIcon size={"sm"}>
                  <ProductIcon size="sm" name="game_store" />
                </CssProductIcon>
                My game: Ultimate Edition
              </div>

              <p style={{ display: "flex", alignItems: "center" }}>
                <StatusDot status={"enabled"} />
                &nbsp;&nbsp;&nbsp;Steam Game Keys:&nbsp;<b>334</b>
              </p>
              <p style={{ display: "flex", alignItems: "center" }}>
                <StatusDot status={"enabled"} />
                &nbsp;&nbsp;&nbsp;GOG Game Keys:&nbsp;<b>123</b>
              </p>
            </CardNew>
          </Link>
        </CSSprovidedGrid>
      )}

      {product === "login" && (
        <CSSprovidedGrid>
          <Link
            to="/login/widget"
            style={{ color: "#00244d", display: "block" }}
          >
            <CardNew style={{ flexGrow: 0, height: "auto" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 16,
                }}
              >
                <CssProductIcon size={"sm"}>
                  <ProductIcon size="sm" name="login" />
                </CssProductIcon>
                Xsolla Login
              </div>

              <p style={{ display: "flex", alignItems: "center" }}>
                <StatusDot status={"enabled"} />
                &nbsp;&nbsp;&nbsp;Users total:&nbsp;<b>32.224</b>
              </p>
            </CardNew>
          </Link>
        </CSSprovidedGrid>
      )}

      {product === "loginUp" && (
        <CSSprovidedGrid>
          <Link
            to="/login/widget"
            style={{ color: "#00244d", display: "block" }}
          >
            <p>Sync users with Mailchimp™</p>
          </Link>
        </CSSprovidedGrid>
      )}

      {product === "subscriptions" && (
        <CSSprovidedGrid>
          <Link
            to="/subscriptions/plans"
            style={{ color: "#00244d", display: "block" }}
          >
            <CardNew style={{ flexGrow: 0, height: "auto" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 16,
                }}
              >
                <CssProductIcon size={"sm"}>
                  <ProductIcon size="sm" name="login" />
                </CssProductIcon>
                Xsolla Subscriptions
              </div>

              <p style={{ display: "flex", alignItems: "center" }}>
                <StatusDot status={"enabled"} />
                &nbsp;&nbsp;&nbsp;Subscription plans:&nbsp;<b>3</b>
              </p>
            </CardNew>
          </Link>
        </CSSprovidedGrid>
      )}
    </div>
  );
};

const Tags = ({}) => {
  const [colsInitial, setColsInitial] = useState(["time", "methods"]);

  return (
    <PAcolumnsTags
      colsInitial={[...colsInitial]}
      setColumns={setColsInitial}
      items={[
        {
          label: "Users over time",
          value: "time",
          required: true,
        },
        {
          label: "Authentication methods",
          value: "methods",
          required: true,
        },
        {
          label: "Users by country",
          value: "country",
        },
      ]}
    />
  );
};

export const ChartSubsContext = React.createContext(null);

export const PAdashSubsCharts = ({
  empty,
  charts = [
    // "time",
    // "plans",
    "country",
  ],
}) => {
  // const [chartSubs, setChartSubs] = useState([...charts])

  return (
    // <ChartSubsContext.Provider value={chartSubs}>
    <FormGroup>
      <DashSection
        cols={
          useContext(GlobalContext).globalState.version === "misha"
            ? false
            : true
        }
      >
        <PAsubsCharts
          charts={charts}
          // charts={[
          //  ...chartSubs
          // ]}
        />

        {/* {useContext(GlobalContext).globalState.version !== "misha" && ( */}
          <Provided product="subscriptions" />
        {/* )} */}
      </DashSection>
    </FormGroup>
    // </ChartSubsContext.Provider>
  );
};

export const CSSprovidedGrid = styled.div`
  display: grid;
  /* display: flex; */
  grid-template-columns: repeat(auto-fit, minmax(280px, 320px));
  grid-column-gap: 24px;
  grid-row-gap: 16px;
`;

export const PAdashUsers = ({
  empty,
  charts = [
    "time",
    "methods",
    // 'country'
  ],
}) => {

  const [ch, setCh] = useState([...charts])

  useEffect(() => {
    if (ch.length !== charts.legth) {
      setCh([...charts])
    }
  }, [charts])

  return (
    <FormGroup>
      <DashSection
        // cols={
        //   useContext(GlobalContext).globalState.version === "misha"
        //     ? false
        //     : true
        // }
        cols={true}
      >
        {/* <PAh2 title="Users and customers" indentation="lg"> */}
        {/* <Tags/> */}
        {/* </PAh2> */}
        <PAloginStats charts={ch} />

        {/* {useContext(GlobalContext).globalState.version !== "misha" && ( */}
          <div style={{display:'flex'}}>
            <Provided product="login" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <Provided product="loginUp" type="upgrade" />
          </div>
        {/* )} */}
      </DashSection>

      <FormGroup>
        {/*
    <TagSelector
          name="locales"
          items={[
            {
              label: 'Status',
              value: 'status',
              width: '1.8fr',
              required: true,
            },
            {
              label: 'Internal id',
              value: 'internal',
              width: '1fr',
            },
            {
              label: 'Subscription plan',
              value: 'plan',
              width: '2.1fr',
              // required: true,
            },
        ]}

        /> */}
      </FormGroup>
    </FormGroup>
  );
};

export const CSSchartfix = styled.div`
  & .highcharts-crosshair-category {
    stroke: transparent;
  }
`;
